module.exports = __webpack_public_path__ + "img/yt-ausdc_usdc.dad2a8a1.png";